// extracted by mini-css-extract-plugin
export var actions = "_pp-4";
export var item = "_pp-1";
export var price = "_pp-3";
export var quantity = "_pp-2";
export var table = "_pp-0";